import SidebarNavMenuItem from '../sidebar/SidebarNavMenuItem';

import type { INavMenu } from '@/components/layout/navbar/navbar.config';
import MobileNavMenuItem from './MobileNavMenuItem';

interface INavMenuItem {
  menuItem: INavMenu;
  toggleText?: boolean;
  isSideBar?: boolean;
  onClick?: () => void;
}

function NavMenuItemV2({ menuItem, onClick, toggleText = true, isSideBar = false }: INavMenuItem) {
  if (isSideBar) {
    return <SidebarNavMenuItem menuItem={menuItem} toggleText={toggleText} onClick={onClick} />;
  }

  return <MobileNavMenuItem menuItem={menuItem} onClick={onClick} />;
}

export default NavMenuItemV2;
